import { store } from '@/store'
import Booking from '@/views/Booking.vue'
import Confirmation from '@/views/Confirmation.vue'
import Home from '@/views/Home.vue'
import { createRouter, createWebHistory } from 'vue-router'

const META_TITLE_BASE = 'Terminvereinbarung'
const META_TITLE_SUFFIX = '| ÖAMTC'
const DEFAULT_MEAT_TITLE = `${META_TITLE_BASE} ${META_TITLE_SUFFIX}`

// Map of step names to their display titles
const STEP_TITLES = {
  1: '1. Angebot',
  2: '2. Fahrzeug',
  3: '3. Stützpunkt',
  4: '4. Termin',
  5: '5. Buchen',
}

// Function to generate a title for a step
const getStepTitle = (step) => {
  const stepTitle = STEP_TITLES[step]
  if (!stepTitle) return DEFAULT_MEAT_TITLE
  return `${META_TITLE_BASE}: ${stepTitle} ${META_TITLE_SUFFIX}`
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
	{
		path: '/:appointmentId',
		name: 'AppointmentId',
		component: Home,
	},
	{
		path:'/bestaetigung/:appointmentId',
		name: 'Confirmation',
		component: Confirmation,
	},
  {
    path: '/',
    query: { bundesland: '' },
    name: 'Service',
    component: Booking,
    meta: { title: getStepTitle(1) },
  },
  {
    path: '/:services',
    query: { bundesland: '' },
    name: 'Vehicle',
    component: Booking,
    meta: { title: getStepTitle(2) },
  },
  {
    path: '/:services',
    query: { bundesland: '', kfzid: '', kfzartid: '' },
    name: 'Station',
    component: Booking,
    meta: { title: getStepTitle(3) },
  },
  {
    path: '/:services/:station',
    query: { bundesland: '', kfzid: '', kfzartid: '' },
    name: 'Appointment',
    component: Booking,
    meta: { title: getStepTitle(4) },
  },
  {
    path: '/:services/:station',
    query: { bundesland: '', kfzid: '', kfzartid: '', tag: '', von: '' },
    name: 'Overview',
    component: Booking,
    meta: { title: getStepTitle(5) },
  },
  { path: '/termine/auth' },
  { path: '/termine/api' },
  { path: '/termine/user' },
  {
    path: '/:catchAll(.*)',
    beforeEnter() {
      window.location.href = 'https://www.oeamtc.at/adsqc'
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // from overview step to any previous step
    if (from.query.tag && !to.query.tag) {
      // for Zuruck button
      if (store.getters.lockedTimeslot) store.dispatch('deleteLockedAppointment')
    }

    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || DEFAULT_MEAT_TITLE
  next()
})

export default router
